'use strict';

/**
 * @module
 * @author Oleg Dutchenko <dutchenko.o.dev@gmail.com>
 * @version 1.0.0
 */

// ----------------------------------------
// Imports
// ----------------------------------------

import { createNewFactory } from '../../utils/create-new-factory';
import { AbstractSelect2 } from './abstract';
import * as factory from './factory';


/**
 * @param {jQuery} containers
 * @private
 */
export function _init(containers) {
    $(containers).each((i, el) => {
        const $container = $(el);
        const data = $container.data('initialize-select2');
        if ($container.hasClass('js-notifications-select2')) {
            data.settings.templateSelection = (data) => {
                const result = data.id + " / " + window.translates.notifications.selectHead;
                return result.toLowerCase();
            }
        }
        /** @type {AbstractSelect2} */
        if ($container.find('.select2').length === 0) {
            const instance = createNewFactory(AbstractSelect2, factory, $container, data);
            instance.initialize();
        }
    })
}


export default function (containers) {
    _init(containers)
}